var styles = {
  "sizeS": "_sizeS_19zxjw2_8",
  "sizeL": "_sizeL_19zxjw2_13",
  "sizeM": "_sizeM_19zxjw2_14",
  "menu": "_menu_19zxjw2_19"
};
export { styles as default };
